<template>
  <div class="order-list-item">
    <!-- SOStatus：任务状态； 待完成：0，待收货：1，已完成：2 -->
    <!-- PayAuditStatus：订单审核状态 -->
    <!-- SpreadAuditStatus: 差价反馈状态 -->
    <div class="item-top">
      <span class="t-txt" v-if="item.PlatformOrderID">订单编号：{{ item.PlatformOrderID }}</span>
      <div class="t-type-txt" v-if="item.SOStatus === 0">
        {{ item.PayAuditStatus | toBeCompleteText(item.SpreadAuditStatus) }}
      </div>
      <span class="t-type-txt" v-else-if="item.SOStatus === 1">等待收货</span>
      <span class="t-type-txt" v-else-if="item.SOStatus === 2">已返利</span>
      <span class="t-type-txt" v-if="item.SOStatus === 4">待搜索</span>
    </div>
    <!-- main -->
    <div class="item-nav" @click="itemClick(item.ProductID)">
      <div class="item-mian">
        <div class="m-img"><img :src="item.PicUrl" /></div>
        <div class="m-right updateItem">
          <div class="topBox">
            <div class="mr-item">
              <div class="txt twoRow">
                <plat-formLogo :shopType="$utils.shopTypeNumChangeToText(item.ShopType)"></plat-formLogo>
                <span>{{ item.TitleShort || '----' }}</span>
              </div>
              <div v-if="item.OrderType">免单卡 x{{ item.FreeCardNum }}</div>
            </div>
            <div class="mr-item">
              <!-- 待收货，已完成：实际支付-返利金额 -->
              <div class="mp price" v-if="item.PayPrice && (item.SOStatus === 1 || item.SOStatus === 2)">￥{{ (item.PayPrice - item.BuyRebatePrice) | formatFloat }}</div>
              <!-- 待完成 -->
              <div class="mp price" v-else-if="item.SOStatus === 0">
                <template v-if="item.BuyRebatePrice"> ￥{{ (item.ProductPrice - item.BuyRebatePrice) | formatFloat }} </template>
                <template v-else> ￥{{ item.SaleDiscountPrice | formatFloat }} </template>
              </div>
              <!-- ``````分割线`````` -->
              <div class="mp discount-price" v-if="item.PayPrice && (item.SOStatus === 1 || item.SOStatus === 2)">￥{{ item.PayPrice | formatFloat }}</div>
              <div class="mp discount-price" v-if="item.ProductPrice && (item.SOStatus === 0 || item.SOStatus === 4)">￥{{ item.ProductPrice | formatFloat }}</div>
              <div class="tr align_left">×1</div>
            </div>
          </div>
          <div class="bottomBox" v-if="item.SOStatus !== 0 && item.Remark">
            {{ item.SOStatus === 2 ? '实际返利：' : '预计返利：' }}
            <span class="price">￥{{ item.BuyRebatePrice | formatFloat }}</span>
          </div>
        </div>
      </div>
      <div class="item-price" v-if="item.SOStatus !== 0 && !item.Remark">
        {{ item.SOStatus === 2 ? '实际返利：' : '预计返利：' }}
        <span class="price">￥{{ item.BuyRebatePrice | formatFloat }}</span>
      </div>
      <!-- 新增商品备注说明 -->
      <div class="remarkPart" v-if="item.Remark">
        <div class="title">购物须知：</div>
        <div class="remarkList">
          <div class="remarkItem" v-for="(item, index) in remarkHandle(item.Remark)" :key="index" v-text="item"></div>
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="min_height">
      <template v-if="item.SOStatus === 0">
        <div class="item-btn" v-if="item.PayAuditStatus === null">
          <template v-if="[0].includes(item.SpreadAuditStatus)">
            <button class="b-btn cancel" @click="checkPeiceFeedback({ itemInfo: item })">
              查看反馈
            </button>
          </template>
          <template v-else>
            <button class="b-btn cancel" @click="cancelOrder(item)">
              取消订单
            </button>
            <button v-if="[1, 2].includes(item.SpreadAuditStatus)" class="b-btn cancel" @click="checkPeiceFeedback({ itemInfo: item })">
              查看反馈
            </button>
            <button class="b-btn sure" @click="continueSubmit(item)">
              继续提交
            </button>
          </template>
        </div>
        <div class="item-btn" v-else-if="item.PayAuditStatus === 1">
          <button class="b-btn sure" @click="waitAudit({ SystemReviewCount: item.SystemReviewCount })">等待审核</button>
        </div>
        <div class="item-btn" v-else-if="item.PayAuditStatus === -1">
          <template v-if="item.SpreadAuditStatus === 0">
            <button class="b-btn cancel" @click="checkPeiceFeedback({ itemInfo: item })">
              查看反馈
            </button>
          </template>
          <template v-else>
            <button class="b-btn cancel" @click="cancelOrder(item)">
              取消订单
            </button>
            <button class="b-btn sure" @click="submitAgain(item.TaskID)">
              重新提交
            </button>
          </template>
        </div>
      </template>
      <template v-else-if="item.SOStatus === 1">
        <div class="item-btn">
          <button class="b-btn cancel" @click="shareClick(item.ProductID)">
            分享好友
          </button>
          <button class="b-btn cancel" @click="confirmReceipt(item.TaskID, item.ProductID, item.ShopType)">
            领取返利
          </button>
        </div>
      </template>
      <template v-else-if="item.SOStatus === 4">
        <div class="item-btn">
          <button class="b-btn cancel" @click="cancelOrder(item)">
            取消订单
          </button>
          <button class="b-btn sure" @click="submitSearch(item)">
            继续搜索
          </button>
        </div>
      </template>
      <template v-else-if="item.SOStatus === 2">
        <div class="item-btn item-btn--btw">
          <van-popover
            v-model="show"
            trigger="click"
            placement="bottom-start"
            :actions="currentActions(item.IsComplain)"
            :overlay="true"
            :close-on-click-action="false"
            @select="onSelect(item, $event)"
          >
            <template #reference>
              <div class="complaint-btn">更多操作</div>
            </template>
          </van-popover>
          <div class="item-btn--right">
            <button class="b-btn cancel" @click="shareClick(item.ProductID)">
              分享好友
            </button>
            <button class="b-btn cancel" @click="checkRebate(item.PlatformOrderID)">
              查看返利
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Popover } from 'vant'
export default {
  components: {
    'van-popover': Popover
  },
  data() {
    return {
      actionsStatus1: [{ text: '我要投诉' }, { text: '删除订单' }],
      actionsStatus2: [{ text: '查看投诉' }, { text: '删除订单' }],
      currentItem: null,
      show: false
    }
  },
  props: {
    item: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  methods: {
    itemClick(productId) {
      this.$emit('entoDetailPage', productId)
    },
    // 等待审核
    waitAudit({ SystemReviewCount = null }) {
      this.$emit('waitAudit', { SystemReviewCount })
    },
    // 取消订单
    cancelOrder(orderInfo) {
      this.$emit('cancelOrder', orderInfo)
    },
    // 继续提交
    continueSubmit(itemData) {
      this.$emit('continueSubmit', itemData)
    },
    // 继续搜索
    submitSearch(itemData) {
      this.$emit('submitSearch', itemData)
    },
    // 重新提交
    submitAgain(taskID) {
      this.$emit('submitAgain', taskID)
    },
    // 领取返利
    confirmReceipt(taskID, productId, shopType) {
      this.$emit('confirmReceipt', taskID, productId, shopType)
    },
    // 查看返利
    checkRebate(PlatformOrderID) {
      this.$emit('checkRebate', PlatformOrderID)
    },
    // 查看反馈
    checkPeiceFeedback(taskID) {
      this.$emit('checkPeiceFeedback', taskID)
    },
    // 投诉
    toComplaint(productId, taskID) {
      this.$router.push({
        name: 'complaintPage',
        query: {
          productId: productId,
          taskId: taskID
        }
      })
    },
    // 投诉详情
    toComplaintDetail(productId, taskID) {
      this.$router.push({
        name: 'complaintDetail',
        query: {
          productId: productId,
          taskId: taskID
        }
      })
    },
    shareClick(productId) {
      this.$router.push({
        name: 'ShareByImg',
        query: {
          type: 'goods',
          productId: productId,
          pageType: 11
        }
      })
    },
    remarkHandle(tempStr) {
      return tempStr.split('；')
    },
    onSelect(item, action) {
      switch (action.text) {
        case '我要投诉':
          this.show = false
          this.$nextTick(() => {
            this.toComplaint(item.ProductID, item.TaskID)
          })
          break
        case '查看投诉':
          this.show = false
          this.$nextTick(() => {
            this.toComplaintDetail(item.ProductID, item.TaskID)
          })
          break
        // 删除订单
        default:
          this.show = false
          this.$nextTick(() => {
            this.$emit('deleteOrder', item.TaskID)
          })
          break
      }
    },
    currentActions(IsComplain) {
      if (IsComplain) {
        return this.actionsStatus2
      } else {
        return this.actionsStatus1
      }
    }
  },
  filters: {
    toBeCompleteText(payAuditStatus, spreadAuditStatus) {
      if (payAuditStatus === null) {
        if (spreadAuditStatus === 0) {
          return '审核中'
        } else {
          return '待完成'
        }
      } else if (payAuditStatus === 1) {
        return '待审核'
      } else if (payAuditStatus === -1) {
        if (spreadAuditStatus === 0) {
          return '审核中'
        } else {
          return '审核不通过'
        }
      }
      return '--'
    },
    formatFloat(val) {
      if (!val) {
        return '0.00'
      }
      return Number(val).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.updateItem {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .topBox {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .bottomBox {
    align-self: flex-end;
  }
}
.remarkPart {
  display: flex;
  min-height: 30px;
  padding: 2px 3% 8px;
  box-sizing: border-box;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  .title {
    height: 20px;
    line-height: 20px;
    margin-top: 6px;
  }
  .remarkList {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex: 1;
    .remarkItem {
      background-color: #f7f7f7;
      border: 1px solid #efefef;
      margin-right: 4px;
      color: #a5a1a4;
      font-size: 12px;
      min-height: 20px;
      padding: 0 3px;
      border-radius: 3px;
      margin-top: 6px;
    }
  }
}
</style>
